const FILE_PREFIX = 'scan-photo';
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

function pad(value: number): string {
    return String(value).padStart(2, '0');
}

// Local calendar date, matching how the scan date is shown in the picker.
function scanDateStamp(scanDate: string): string | null {
    const dateOnly = DATE_ONLY.exec(scanDate);
    if (dateOnly) return `${dateOnly[1]}-${dateOnly[2]}-${dateOnly[3]}`;
    const date = new Date(scanDate);
    if (Number.isNaN(date.getTime())) return null;
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

// The name leaves ODO with the message, so it carries the scan date and nothing that identifies the patient.
export function buildScanPhotoFileName(scanDate: string | null | undefined): string {
    const stamp = scanDate ? scanDateStamp(scanDate.trim()) : null;
    return stamp ? `${FILE_PREFIX}-${stamp}.jpg` : `${FILE_PREFIX}.jpg`;
}
